import "core-js/modules/es.array.find";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addReplenishment from "./components/addReplenishment.vue";
import { repairOrderData, auditRepairOrder } from "@/api/gmToolNew/gmToolNew";
import viewArticles from "../email/components/viewArticles.vue";
import { gmToolNew, gmToolNewPage } from "@/mixins/index";
export default {
  name: "yjreplenishment",
  mixins: [gmToolNew, gmToolNewPage],
  components: {
    addReplenishment: addReplenishment,
    viewArticles: viewArticles
  },
  data: function data() {
    return {
      advanced: false,
      currentPage: 1,
      tableData: [],
      paramsData: {
        order_id: "",
        product_id: "",
        pay_type: "",
        uid: "",
        page: 1
      },
      date: [],
      total: 0
    };
  },
  created: function created() {},
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    addItem: function addItem() {
      if (this.show_test !== 1 && this.show_test !== 0) {
        this.$message.error(this.$t('pleaseSelectShowTestServer'));
        return;
      }

      this.$refs.addReplenishment.open({}, false);
    },
    getList: function getList(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this.paramsData.server_id.length == 0)) {
                  _context2.next = 3;
                  break;
                }

                _this.$message.error(_this.$t('pleaseSelectServer'));

                return _context2.abrupt("return");

              case 3:
                _this.paramsData.page = e;
                _this.reqLoading = true;
                repairOrderData(_this.paramsData).then(function (res) {
                  if (res.status == 200) {
                    _this.tableData = res.data.data;
                    _this.total = res.data.total;
                  }
                }).finally(function () {
                  _this.reqLoading = false;
                });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    exportdata: function exportdata() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var list, columns;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                list = [];
                _context3.next = 3;
                return repairOrderData({
                  page: 1,
                  page_size: _this2.total,
                  server_id: _this2.paramsData.server_id,
                  game_id: _this2.rawData.game_id,
                  env_id: _this2.paramsData.env_id
                }).then(function (res) {
                  if (res.status == 200) {
                    res.data.data.map(function (i) {
                      i.pay_type = _this2.payType.find(function (j) {
                        return j.value == i.pay_type;
                      }).label;
                    });
                    list = res.data.data;
                  }
                });

              case 3:
                columns = [{
                  label: _this2.$t('operator'),
                  prop: 'admin_name'
                }, {
                  label: _this2.$t('gameUid'),
                  prop: 'uid'
                }, {
                  label: _this2.$t('orderId'),
                  prop: 'order_id'
                }, {
                  label: _this2.$t('productId'),
                  prop: 'product_id'
                }, {
                  label: _this2.$t('paymentMethod'),
                  prop: 'pay_type'
                }, {
                  label: _this2.$t('items'),
                  prop: 'reward'
                }, {
                  label: _this2.$t('replenishmentTime'),
                  prop: 'created_at'
                }];

                _this2.$export.excel({
                  columns: columns,
                  data: list,
                  title: _this2.$route.meta.title
                });

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};